import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CampaignModel } from 'src/app/models/CampaignModel';
import { CampaignUDF1StepModel } from 'src/app/models/CampaignUDF1StepModel';
import { RequestModel } from 'src/app/models/RequestModel';
import { TreesViewModel } from 'src/app/models/TreesViewModel';
import { UdfControlType } from 'src/app/models/UdfControlType';

@Component({
    selector: 'app-step3',
    templateUrl: './step3.component.html',
    styleUrls: ['./step3.component.css']
})
export class Step3Component implements OnInit {
    get model(): TreesViewModel { return this._model; }
    @Input() set model(value: TreesViewModel) {
        this._model = value;
        this.campaign = value.campaign;
        this.request = value.request;
        if (value !== null) {
            this.initForm();
            this.udfs = this.campaign.udf3;
        }
    }
    request: RequestModel = null;
    campaign: CampaignModel = null;

    private _model: TreesViewModel;

    udfs: CampaignUDF1StepModel[] = null;
    initialsForm: FormGroup = null;
    udfForms: FormArray;

    constructor() { }

    ngOnInit(): void {

    }
    isValid(): boolean {
        for (let i = 0; i < this.campaign.udf3.length; i++) {
            let udf  = this.campaign.udf3[i];
            let ctl = this.udfForms.controls[i];
            if (udf.uDFIControlType === UdfControlType.CheckBox){
                if (ctl.value !== true){
                    return false;
                }
            }
        }
        return this.initialsForm .valid && this.udfForms.status === 'VALID';
    }
    
    private initForm(): void {
        this.udfForms = new FormArray([]);
        for (const udf of this.campaign.udf3) {
            let control: FormControl;
            if (udf.uDFIControlType === UdfControlType.CheckBox) {
                control = new FormControl(udf.value);
            } else {
                control = new FormControl(udf.value);
                if (udf.uDFIsRequired) {
                    control.setValidators([Validators.required,Validators.maxLength(64)]);
                }
            }
            this.udfForms.push(control);
        }
        this.initialsForm = new FormGroup({
            initials1: new FormControl(this.request.initialsAcceptAbove, [Validators.required,Validators.maxLength(4)]),
            initials2: new FormControl(this.request.initialsReleaseOfLiability, [Validators.required,Validators.maxLength(4)]),
        });
    }

    updateModel(): void {
        for (let i = 0; i < this.campaign.udf3.length; i++) {
            const udf = this.campaign.udf3[i];
            udf.value = this.udfForms.value[i];
        }
        this.request.initialsAcceptAbove = this.initialsForm.controls.initials1.value;
        this.request.initialsReleaseOfLiability = this.initialsForm.controls.initials2.value;
    }

    get f(): any { return this.initialsForm.controls; }

}
